// LocalizationInitializer.tsx
import React, { useEffect } from 'react';
import { useLocalization } from '@progress/kendo-react-intl';
import { setLocalizationService } from './localizationService';

const LocalizationInitializer = ({ onReady }) => {
  const localizationService =  useLocalization();

  useEffect(() => {
    console.log(localizationService);
    setLocalizationService(localizationService);
    onReady();
  }, [localizationService,onReady]);

  return null; // This component only initializes localization globally
};

export default LocalizationInitializer;
